// extracted by mini-css-extract-plugin
export default {"container":"gj-z","blurb":"hj-z","links":"ij-z"};